<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline select-nobg">
					<el-form-item label="链接名称" prop="title">
						<el-input v-model="formInline.title" placeholder="请输入链接名称" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="描述" prop="linkDescribe">
						<el-input v-model="formInline.linkDescribe" placeholder="请输入描述" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="投放链接ID" prop="tfid">
						<el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="代理商姓名" prop="agentId" v-if="!isAgent">
						<el-select v-model="formInline.agentId" placeholder="请选择代理商姓名" clearable @change="search" filterable >
							<el-option
									v-for="item in agentIdOptions"
									:key="item.id"
									:label="item.nickName"
									:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间：">
						<el-date-picker
								v-model="dataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
					<br/>
					<el-form-item label="充值时间：">
						<el-date-picker
							v-model="recDataTime"
							class="pickerData"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="充值金额 > ">
						<el-input type="number" placeholder="请输入充值金额" v-model="formInline.recCustom" class="input-with-select" clearable>
							<!-- <el-select v-model="topUpType" slot="prepend" @change="changeTopUpType" style="width: 150px;">
								<el-option
								v-for="item in topUpTypeOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
								></el-option>
							</el-select> -->
						</el-input>
						<!--<el-select v-model="topUpType" @change="changeTopUpType" style="width: 150px;">-->
							<!--<el-option-->
									<!--v-for="item in topUpTypeOptions"-->
									<!--:key="item.value"-->
									<!--:label="item.label"-->
									<!--:value="item.value"-->
							<!--&gt;</el-option>-->
						<!--</el-select>-->
						<!--<el-input v-if="topUpType == '1'" type="number" v-model="formInline.recDay" placeholder="请输入金额" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>-->
						<!--<el-input v-if="topUpType == '2'" type="number" v-model="formInline.recYesterday" placeholder="请输入金额" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>-->
						<!--<el-input v-if="topUpType == '3'" type="number" v-model="formInline.recTotal" placeholder="请输入金额" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>-->
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="" label="序号" width="100">
						<template slot-scope="scope">
							<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="代理商信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>代理商姓名：{{scope.row.nickName}}</p>
								<p>小程序名称：{{scope.row.appidName}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="投放链接信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>链接ID：{{scope.row.id}}</p>
								<p>链接名称：<b class="succes-text">{{scope.row.title}}</b></p>
								<p>描述：<b class="danger-text">{{scope.row.linkDescribe}}</b></p>
								<p>书名：{{scope.row.bookName}}</p>
								<p>创建时间：{{ scope.row.linkAddTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="昨日充值数据" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>昨日充值人数: {{scope.row.recDayYesterdayUserNum || 0}}</p>
								<p>昨日充值笔数: {{scope.row.recYesterdayNum || 0}}</p>
								<p>昨日充值金额: {{scope.row.recYesterday || 0}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="当日充值数据" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日充值人数: {{scope.row.recDayUserNum || 0}}</p>
								<p>当日充值笔数: {{scope.row.recDayNum || 0}}</p>
								<p>当日充值金额: {{scope.row.recDay || 0}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="累计总用户数据" >
						<template slot-scope="scope">
							<div class="td-info">
								<p>总用户数: {{scope.row.userNumTotal || 0}}</p>
								<p>总充值人数: {{scope.row.recUserNumTotal || 0}}</p>
								<p>总充值金额: {{scope.row.recTotal || 0}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="累计订单数">
						<template slot-scope="scope">
							<div class="td-info">
								<p>总订单数：{{scope.row.orderNumTotal || 0}}</p>
								<p>未支付数：{{scope.row.orderNoPayNumTotal || 0}}</p>
								<p>支付数：{{scope.row.orderPayNumTotal || 0}}</p>
								<p>充值成功率：{{scope.row.paymentRate || 0}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<!--<el-pagination @current-change="handleCurrentChange" :page-size="tableData.pageSize"-->
					<!--background :current-page="currentPage" :total="tableData.totalNum">-->
					<!--</el-pagination>-->
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" width="1600px">
			<div class="top-search">
				<el-form :inline="true" :model="detailformInline" ref="detailformInline" size="small" class="demo-form-inline">
					<el-form-item label="时间：">
						<el-date-picker
								v-model="detailDataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="detailSearch">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="detailSearch">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="detailResetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableLinkData.result" border stripe style="width: 100%;" height="100%" class="tableStyle" v-loading="linkLoading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{(tableLinkData.pageNo - 1)* tableLinkData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="statDate" label="日期" width="100"></el-table-column>
					<el-table-column prop="title" label="代理商信息" width="180">
						<template slot-scope="scope">
							<div class="td-info">
								<p>代理商姓名：{{scope.row.nickname}}</p>
								<p>小程序名称：{{scope.row.appidName}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="投放链接信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>链接名称：{{scope.row.title}}</p>
								<p>描述：{{scope.row.linkDescribe}}</p>
								<p>书名：{{scope.row.bookName}}</p>
								<p>创建时间：{{ scope.row.linkAddTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="当日推广充值数据" width="140">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日充值人数：{{scope.row.recDayUserNum - scope.row.continuousSubscriptionNum}}</p>
								<p>当日充值笔数：{{scope.row.recDayNum - scope.row.continuousSubscriptionNum}}</p>
								<!-- <p>当日充值金额：{{ scope.row.recDay  - scope.row.continuousSubscriptionMoney}}</p> -->
								<p>当日充值金额：{{ preciseSubtract(scope.row.recDay,scope.row.continuousSubscriptionMoney)}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="当日会员数据">
						<template slot-scope="scope">
							<div class="td-info">
								<p>连续包月：{{ scope.row.continuousMonthlySubscriptionNum }}</p>
								<p>连续包月：{{scope.row.continuousPackageQuarterlyNum}}</p>
								<p>普通会员人数：{{scope.row.ordinaryNum}}</p>
								<!--<p>包月会员：</p>-->
								<!--<p>包季会员：</p>-->
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="当日订单数据">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日订单数：{{ scope.row.recDayOrderNumTotal}}</p>
								<p>当日未支付数：{{ scope.row.recDayOrderNoPayNumTotal }}</p>
								<p>当日支付数：{{ scope.row.recDayNum }}</p>
								<p>当日充值成功率：{{ scope.row.recDayPaymentRate }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="新用户数据">
						<template slot="header">
							<el-tooltip class="item" effect="dark" placement="top">
								<div slot="content">新用户人均充值：新用户充值金额/新用户数<br/>新用户付费率：新用户充值人数/新用户数*100%</div>
								<p>新用户数据</p>
							</el-tooltip>
						</template>
						<template slot-scope="scope">
							<div class="td-info">
								<p>新用户数: {{scope.row.newUserNum}}</p>
								<p>新用户充值人数: {{scope.row.newUserRecUserNum}}</p>
								<p>新用户充值金额:  {{scope.row.newUserRec}}</p>
								<p>新用户人均充值:  {{scope.row.newUserAvgRec}}</p>
								<p>新用户付费率:  {{scope.row.newUserPaymentRate}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="首充用户数据" width="170">
						<template slot-scope="scope">
							<div class="td-info">
								<p>首充用户数：{{ scope.row.firstChargeNum }}</p>
								<p>首充用户充值金额：{{ scope.row.firstChargeMoney }}</p>
								<!-- <p>首充用户人均充值：{{ scope.row.firstChargeNum === 0 ? 0 : scope.row.firstChargeMoney / scope.row.firstChargeNum }}</p> -->
								<p>首充用户人均充值：{{ scope.row.firstChargeNum === 0 ? 0 : preciseMultiplyNew( scope.row.firstChargeMoney,scope.row.firstChargeNum ) }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="续订用户数据">
						<template slot-scope="scope">
							<div class="td-info">
								<p>续订用户数：{{ scope.row.continuousSubscriptionNum}}</p>
								<p>续订金额：{{ scope.row.continuousSubscriptionMoney }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="回传信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>当日付费回传笔数：{{scope.row.retPayNum}}</p>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChangeLink"
							@size-change="handleSizeChangeLink"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableLinkData.pageSize"
							background
							:current-page="linkCurrentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableLinkData.totalNum">
					</el-pagination>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="margin-top: 20px;">
				<el-button type="primary" @click="closeDialogBtn">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
    import { list, agentlist, linklist } from "@/api/wb/data/link";
    export default {
        data() {
            return {
                loading: false,
                linkLoading:false,
                dataTime: [],
								recDataTime:[],
                topUpType: '1',
                topUpTypeOptions: [
                    {
                        label: '今日充值金额  >',
                        value: '1'
                    },
                    {
                        label: '昨日充值金额  >',
                        value: '2'
                    },
                    {
                        label: '累计充值金额  >',
                        value: '3'
                    }
                ],
                inputMoney: '',
                formInline: {
                    title: '',
                    linkDescribe: '',
                    tfid: '',
                    agentId: '',
                    startTime: '',
                    endTime: '',
                    appid: localStorage.getItem('appId'),
                    recDay: '',
                    recYesterday: '',
                    recTotal: '',
										recDataTime:'',
										sTime:'',
										eTime:'',
										recCustom:''
                },
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: [
                    ]
                },
                tableLinkData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: [
                    ]
                },
                currentPage: 1,
                linkCurrentPage:1,
                dialogInfoVisible: false,
                rowForm: {},
                agentIdOptions:[],
                isAgent:false,
                linkId:'',
                detailformInline:{
                    startTime: '',
                    endTime: '',
                },
                detailDataTime:[],
            }
        },
        computed: {},
        watch: {
        },
        mounted: function() {
            if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId){
                this.isAgent = true
                this.formInline.appid = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
            }
            this.loading = true
            this.getTableData()
            this.getAgentList()
        },
        methods: {
            // 从组件获取appid
            getAppId(data) {
                this.formInline.appid = data
                this.loading = true
                this.getTableData()
            },
            changeTopUpType (val) {
                console.log(val)
								this.topUpType = val
                this.formInline.recDay = ''
                this.formInline.recYesterday = ''
                this.formInline.recTotal = ''
                // this.search()
            },
            search() {
                this.currentPage = 1
								if(this.recDataTime.length > 0 && !this.formInline.recCustom){
									this.$message.error("请填写您要筛选的充值金额！")
									return ;
								}
                this.loading = true
                if (this.topUpType == '1') {
                    this.formInline.recDay = this.inputMoney
                } else if (this.topUpType == '2') {
                    this.formInline.recYesterday = this.inputMoney
                } else if (this.topUpType == '3') {
                    this.formInline.recTotal = this.inputMoney
                }
                this.getTableData()
            },
            resetQuery(){
                this.loading = true
                this.topUpType = '1'
                this.inputMoney = ''
                this.$refs['formInline'].resetFields()
                this.dataTime = []
                this.recDataTime = []
                this.getTableData()
            },
            // pageSize切换
            handleSizeChange (val) {
                this.tableData.pageSize  = val
                this.currentPage = 1
                this.loading = true
                this.getTableData()
            },
            handleCurrentChange(value) {
                this.currentPage = value
                this.loading = true
                this.getTableData()
            },
            // 详情pageSize切换
            handleSizeChangeLink (val) {
                this.tableData.pageSize  = val
                this.linkCurrentPage = 1
                this.linkLoading = true
                this.getTableLinkData(this.linkId)
            },
            handleCurrentChangeLink(value) {
                this.linkCurrentPage = value
                this.linkLoading = true
                this.getTableLinkData(this.linkId)
            },
            //详情搜索和重置
            detailSearch() {
                this.linkLoading = true,
                this.linkCurrentPage = 1
                this.getTableLinkData(this.linkId)
            },
            detailResetQuery(){
                this.$refs['detailformInline'].resetFields()
                this.linkLoading = true,
                    this.detailDataTime = []
                this.getTableLinkData(this.linkId)
            },
            handleLook(row) {
                this.dialogInfoVisible = true
                this.rowForm = row
                this.linkLoading = true
                this.linkId = row.id
                this.detailDataTime = []
                this.linkCurrentPage = 1
                this.getTableLinkData(row.id)
            },
            // 列表
            getTableData() {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
                this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
                this.formInline.sTime = this.recDataTime ? this.recDataTime[0] : ''
                this.formInline.eTime = this.recDataTime ? this.recDataTime[1] : ''
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                linklist(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                        this.loading = false
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                }).catch(() => {
                    this.loading = false
                });
            },
            //获取代理商列表
            getAgentList(){
                agentlist().then(response => {
                    if (response.data.head.flag === 0) {
                        this.agentIdOptions = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
            //获取链接详情列表
            getTableLinkData(tfid){
                let json2 = {
                    pageNo: this.linkCurrentPage,
                    pageSize: this.tableLinkData.pageSize
                };
                // this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
                // this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
                const startTime = this.detailDataTime ? this.detailDataTime[0] : ''
                const endTime = this.detailDataTime ? this.detailDataTime[1] : ''
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2,tfid,startTime,endTime };
                console.log("paramJson",paramJson)
                list(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableLinkData = response.data.content
                        this.linkLoading = false
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
            //详情弹窗关闭
            closeDialogBtn(){
                this.dialogInfoVisible = false
            },
						// 精确减法：num1 - num2
						preciseSubtract(num1, num2) {
							// 处理非数字情况
							if (isNaN(num1) || isNaN(num2)) return 0;
							
							// 转换为字符串，获取小数位数
							const decimalLen1 = (num1.toString().split('.')[1] || '').length;
							const decimalLen2 = (num2.toString().split('.')[1] || '').length;
							
							// 计算放大倍数（避免浮点数运算）
							const maxLen = Math.max(decimalLen1, decimalLen2);
							const multiplier = Math.pow(10, maxLen);
							
							// 转为整数运算后再缩小
							return (num1 * multiplier - num2 * multiplier) / multiplier;
						},
						// 精确除法
						preciseMultiplyNew(num1, num2){
							return (num1 / num2).toFixed(2)
						}

        }
    }
</script>
